import { formatDate } from "@/utils/helper";
import { faArrowRightLong } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import Link from "next/link";
import Container from "../common/Container";

const BlogHero = ({ blog, latestImage, category }) => {
  return (
    <div className="relative">
      <div className="bg-header-background bg-bottom bg-cover bg-no-repeat pt-8 pb-96 absolute right-0 left-0 top-0"></div>
      <Container large className="pb-36 lg:pb-40 bg-primary-black">
        <div className="pt-32 xl:pt-48 z-10 relative">
          <div className="flex flex-col md:flex-row pb-16 justify-between">
            <div className="md:w-1/2">
              <p className="font-medium text-primary-yellow text-xl !mb-5">
                <span>{category[0]}</span>
              </p>
              <h1 className="font-bold !text-white text-4xl leading-normal lg:text-6xl !mb-5 lg:leading-tight text-ellipsis overflow-hidden line-clamp-3 lg:w-10/12">
                <span> {blog[0]?.title.rendered}</span>
              </h1>
              <p className="!text-white text-opacity-10 text-sm lg:text-base !mb-5 lg:!mb-10">
                <span>
                  {blog[0]?.date ? formatDate(blog[0].date) : <>&nbsp;</>}
                </span>
              </p>
              <div
                className="!text-white text-base lg:text-xl !mb-9 md:w-4/5 tracking-wider line-clamp-3"
                dangerouslySetInnerHTML={{
                  __html: blog[0]?.excerpt.rendered,
                }}
              ></div>
              <Link href={`/blog/${blog[0]?.slug}`} passHref>
                <a className="font-semibold text-primary-yellow text-lg flex items-center pb-7 lg:pb-0 w-fit">
                  {blog[0] && (
                    <>
                      <span>Start Reading</span>
                      <span>
                        <FontAwesomeIcon
                          height={20}
                          icon={faArrowRightLong}
                          width={40}
                        />
                      </span>
                    </>
                  )}
                </a>
              </Link>
            </div>
            <div className="fs-0 md:w-3/5 lg:w-auto">
              <Link href={`/blog/${blog[0]?.slug}`}>
                <a className="mx-auto">
                  <Image
                    src={latestImage[0]?.sourceUrl ?? "/"}
                    width={646}
                    height={543}
                    alt={latestImage[0]?.alt_text ?? ""}
                    className="rounded-2xl"
                    priority
                  />
                </a>
              </Link>
            </div>
          </div>
          <div className="flex flex-col gap-4 md:gap-0 md:flex-row rounded-xl overflow-hidden">
            {blog.slice(1, 3)?.map((items, index) => (
              <Link key={index} href={`blog/${items?.slug}`}>
                <a
                  className={`!p-2 md:w-1/2 md:!py-5 md:!px-0 bg-[#211819] rounded-xl md:rounded-none ${
                    index === 1 ? "md:!pl-[54px]" : "md:!pl-5"
                  }`}
                >
                  <div className="flex !gap-x-5 lg:!gap-x-7">
                    <div className="fs-0 md:w-4/12">
                      <div className="xl:w-52">
                        <Image
                          src={latestImage[index + 1]?.sourceUrl ?? "/"}
                          height={162}
                          width={198}
                          alt={latestImage[index + 1]?.alt_text ?? ""}
                          className="rounded-2xl overflow-hidden"
                        />
                      </div>
                    </div>
                    <div
                      className={`w-8/12 ${
                        index === 0
                          ? "md:border-r md:border-solid md:border-white md:border-opacity-20 md:pr-[54px]"
                          : ""
                      }`}
                    >
                      <p className="font-medium text-primary-yellow text-xs lg:text-xl !pt-1 lg:!pt-0 !pb-2 lg:!pb-4">
                        <span>{category[index + 1]}</span>
                      </p>
                      <h2
                        className={`font-semibold text-xl lg:text-2xl text-white !pb-1 lg:!mb-3 leading-snug text-ellipsis overflow-hidden line-clamp-2 ${
                          index === 1 ? "md:!pr-7" : ""
                        }`}
                      >
                        <span>{items?.title.rendered}</span>
                      </h2>
                      <p className="text-xs lg:text-base text-white">
                        <span>{formatDate(items?.date)}</span>
                      </p>
                    </div>
                  </div>
                </a>
              </Link>
            ))}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default BlogHero;
